import { combineReducers } from "redux";

import getEvents from "./getEvents";
import getPrograms from "./getPrograms";
import getVotes from "./getVotes";
import getProfileCandidate from "./getProfileCandidate";
import handleVote from "./handleVote";
import getVoteResult from "./getVoteResult";
import getDetailEvent from "./getDetailEvent";
import getDetailProgram from "./getDetailProgram";
import getPostRemaining from "./getPostRemaining";

const newsReducer = combineReducers({
  getEvents,
  getProfileCandidate,
  handleVote,
  getVoteResult,
  getPrograms,
  getVotes,
  getDetailEvent,
  getDetailProgram,
  getPostRemaining,
});

export default newsReducer;
